module.exports = __webpack_public_path__ + "img/retailer-deezer.109d6a6b.svg";